import Offering from '../dto/offering/Offering'
import {i18n} from '../plugin/vue-i18n';
import moment from 'moment/moment'

export default class MessageBuilder {
    static getBookableMessage(offering) {
        if (!(offering instanceof Offering)) {
            return '';
        }

        let $resultString = '';
        if (offering.bookingType === Offering.BOOKING_TYPE_PER_APPOINTMENT) {
            if (offering.bookingStartPerAppointmentAmount && offering.bookingStartPerAppointmentType) {
                $resultString += i18n.t('offering.bookingStart') + ' '
                    + offering.bookingStartPerAppointmentAmount + ' '
                    + i18n.t('offeringBookingType.perAppointment.' + offering.bookingStartPerAppointmentType) + ' '
                    + i18n.t('offeringBookingType.perAppointment.label');
            }
            if (offering.bookingStartPerAppointmentAmount && offering.bookingEndPerAppointmentAmount) {
                $resultString += '\n'
            }
            if (offering.bookingEndPerAppointmentAmount && offering.bookingEndPerAppointmentType) {
                $resultString += i18n.t('offering.bookingEnd') + ' '
                    + offering.bookingEndPerAppointmentAmount + ' '
                    + i18n.t('offeringBookingType.perAppointment.' + offering.bookingEndPerAppointmentType) + ' '
                    + i18n.t('offeringBookingType.perAppointment.label');
            }
        } else {
            if (offering.bookingStart) {
                $resultString += i18n.t('offering.fromStart') + ' '
                    + moment(offering.bookingStart, 'YYYY-MM-DD').format('DD.MM.YYYY') + ' ';
            }
            if (offering.bookingEnd) {
                $resultString += i18n.t('offering.toEnd') + ' '
                    + moment(offering.bookingEnd, 'YYYY-MM-DD').format('DD.MM.YYYY');
            }
        }
        if ($resultString === '') {
            $resultString = '-';
        }
        return $resultString;
    }
}
